import {  EDIT_JOB_REQUEST,  EDIT_JOB_SUCCESS,  EDIT_JOB_FAIL } from "../constants/AuthConstant"

const initialState = {
  loading: false,
  action: "Edit Job Action",
  result: null,
  msg: "",
  error: "",
};

const EditJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case  EDIT_JOB_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case  EDIT_JOB_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case  EDIT_JOB_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default EditJobReducer;
